
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7gCQU", function(module, exports) {
$parcel$export(module.exports, "createBrowserHistory", () => (parcelRequire("lI7ls")).createBrowserHistory);
$parcel$export(module.exports, "Router", () => (parcelRequire("1meBc")).Router);
$parcel$export(module.exports, "Redirect", () => (parcelRequire("ij09r")).Redirect);
$parcel$export(module.exports, "useResource", () => (parcelRequire("jfaTG")).useResource);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("hBMVl")).useRouter);
$parcel$export(module.exports, "createResource", () => (parcelRequire("dmaNf")).createResource);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("hBMVl")).useRouterActions);
$parcel$export(module.exports, "createRouterSelector", () => (parcelRequire("bYNku")).createRouterSelector);
$parcel$export(module.exports, "RouteComponent", () => (parcelRequire("cfo3c")).RouteComponent);
$parcel$export(module.exports, "Link", () => (parcelRequire("502Pt")).default);

var $lI7ls = parcelRequire("lI7ls");

parcelRequire("1n3WU");
var $dmaNf = parcelRequire("dmaNf");
var $bYNku = parcelRequire("bYNku");
var $ij09r = parcelRequire("ij09r");
var $1meBc = parcelRequire("1meBc");
var $jfaTG = parcelRequire("jfaTG");
var $hBMVl = parcelRequire("hBMVl");

parcelRequire("b9UAi");
var $502Pt = parcelRequire("502Pt");
var $cfo3c = parcelRequire("cfo3c");


var $9xXrE = parcelRequire("9xXrE");
var $dfiOc = parcelRequire("dfiOc");
var $kYOHF = parcelRequire("kYOHF");
var $3tzSy = parcelRequire("3tzSy");


});

parcelRegister("1n3WU", function(module, exports) {
$parcel$export(module.exports, "RouterSubscriber", () => (parcelRequire("aRGWR")).RouterSubscriber);
$parcel$export(module.exports, "Router", () => (parcelRequire("1meBc")).Router);
$parcel$export(module.exports, "Redirect", () => (parcelRequire("ij09r")).Redirect);
$parcel$export(module.exports, "useResource", () => (parcelRequire("jfaTG")).useResource);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("hBMVl")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("hBMVl")).useRouterActions);
$parcel$export(module.exports, "createResource", () => (parcelRequire("dmaNf")).createResource);
$parcel$export(module.exports, "createRouterSelector", () => (parcelRequire("bYNku")).createRouterSelector);
parcelRequire("fo7Me");
var $aRGWR = parcelRequire("aRGWR");


var $1meBc = parcelRequire("1meBc");


var $1pe0f = parcelRequire("1pe0f");


var $3XHCa = parcelRequire("3XHCa");


var $3dDXt = parcelRequire("3dDXt");


var $ij09r = parcelRequire("ij09r");


var $jLcR8 = parcelRequire("jLcR8");

parcelRequire("lYh42");
var $jfaTG = parcelRequire("jfaTG");
var $hBMVl = parcelRequire("hBMVl");


var $aMVOn = parcelRequire("aMVOn");


var $dmaNf = parcelRequire("dmaNf");


var $bYNku = parcelRequire("bYNku");


});

parcelRegister("b9UAi", function(module, exports) {
$parcel$export(module.exports, "Link", () => (parcelRequire("502Pt")).default);
$parcel$export(module.exports, "RouteComponent", () => (parcelRequire("cfo3c")).RouteComponent);

var $502Pt = parcelRequire("502Pt");


var $cfo3c = parcelRequire("cfo3c");


});

parcelRegister("9xXrE", function(module, exports) {
$parcel$export(module.exports, "warmupMatchRouteCache", () => (parcelRequire("d8Wx9")).warmupMatchRouteCache);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("dfiOc")).default);
$parcel$export(module.exports, "generateLocationFromPath", () => (parcelRequire("3Mxds")).generateLocationFromPath);
$parcel$export(module.exports, "isServerEnvironment", () => (parcelRequire("7Yci1")).isServerEnvironment);
$parcel$export(module.exports, "findRouterContext", () => (parcelRequire("3tzSy")).findRouterContext);
$parcel$export(module.exports, "createRouterContext", () => (parcelRequire("3tzSy")).createRouterContext);

var $d8Wx9 = parcelRequire("d8Wx9");


var $dfiOc = parcelRequire("dfiOc");


var $3Mxds = parcelRequire("3Mxds");


var $kYOHF = parcelRequire("kYOHF");


var $7Yci1 = parcelRequire("7Yci1");


var $3tzSy = parcelRequire("3tzSy");


});

parcelRegister("fo7Me", function(module, exports) {
$parcel$export(module.exports, "RouterSubscriber", () => (parcelRequire("aRGWR")).RouterSubscriber);

var $9hl2F = parcelRequire("9hl2F");


var $aRGWR = parcelRequire("aRGWR");


});

parcelRegister("1meBc", function(module, exports) {

var $ccS36 = parcelRequire("ccS36");


var $cozmU = parcelRequire("cozmU");


var $edaDW = parcelRequire("edaDW");


var $bYNku = parcelRequire("bYNku");

class $0fd32b97534ebb25$export$55185c17a0fcbe46 extends (0, $cozmU.Component) {
    componentDidMount() {
        if (!this.props.isStatic) {
            const state = (0, $bYNku.getRouterState)();
            this.unlistenHistory = state.unlisten;
        }
    }
    /**
   * Ensures that the router store stops listening to history when the Router
   * is unmounted.
   */ componentWillUnmount() {
        if (this.unlistenHistory) this.unlistenHistory();
    }
    render() {
        const { children: children, routes: routes, history: history, initialRoute: initialRoute, isStatic: isStatic, isGlobal: isGlobal, basePath: basePath, resourceContext: resourceContext, resourceData: resourceData, onPrefetch: onPrefetch } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bYNku.RouterContainer), {
            basePath: basePath,
            routes: routes,
            history: history,
            initialRoute: initialRoute,
            isStatic: isStatic,
            resourceContext: resourceContext,
            resourceData: resourceData,
            onPrefetch: onPrefetch,
            isGlobal: isGlobal
        }, children);
    }
    constructor(...args){
        super(...args);
        (0, $ccS36.default)(this, "unlistenHistory", null);
    }
}
(0, $ccS36.default)($0fd32b97534ebb25$export$55185c17a0fcbe46, "defaultProps", {
    isStatic: false,
    isGlobal: true,
    history: (0, $edaDW.DEFAULT_HISTORY)
});
module.exports["Router"] = $0fd32b97534ebb25$export$55185c17a0fcbe46;

});

parcelRegister("1pe0f", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $cozmU = parcelRequire("cozmU");


var $lI7ls = parcelRequire("lI7ls");


var $1meBc = parcelRequire("1meBc");

const $1062fcee15616e28$var$getRouterProps = (memoryRouterProps)=>{
    const { isStatic: isStatic = false, isGlobal: isGlobal = true, basePath: basePath, routes: routes, resourceData: resourceData, resourceContext: resourceContext } = memoryRouterProps;
    let routerProps = {
        basePath: basePath,
        routes: routes,
        isStatic: isStatic,
        isGlobal: isGlobal
    };
    if (resourceData) routerProps = (0, $eb3ax.default)((0, $eb3ax.default)({}, routerProps), {}, {
        resourceData: resourceData
    });
    if (resourceContext) routerProps = (0, $eb3ax.default)((0, $eb3ax.default)({}, routerProps), {}, {
        resourceContext: resourceContext
    });
    return routerProps;
};
const $1062fcee15616e28$export$ae46f04cfaffe093 = (props)=>{
    const { location: location, children: children } = props;
    const config = {};
    if (location) config.initialEntries = [
        location
    ];
    const history = (0, $lI7ls.createMemoryHistory)(config);
    const routerProps = $1062fcee15616e28$var$getRouterProps(props);
    return(/*#__PURE__*/ // @ts-ignore suppress history will be overwritten warning
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1meBc.Router), (0, $eb3ax.default)({
        history: history
    }, routerProps), children));
};
module.exports["MemoryRouter"] = $1062fcee15616e28$export$ae46f04cfaffe093;

});

parcelRegister("3XHCa", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $cozmU = parcelRequire("cozmU");


var $lI7ls = parcelRequire("lI7ls");




var $gvC5e = parcelRequire("gvC5e");




var $1pe0f = parcelRequire("1pe0f");


var $aMVOn = parcelRequire("aMVOn");


var $bYNku = parcelRequire("bYNku");

const $2e28b6be6a2e8b94$export$cac06da4d76d935b = ({ location: location, routes: routes, children: children, basePath: basePath })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1pe0f.MemoryRouter), {
        location: location,
        routes: routes,
        basePath: basePath,
        isStatic: true
    }, children);
/**
 * The entry point for requesting resource data on the server.
 * Pass the result data into the router as a prop in order to hydrate it.
 * TODO: return type (see imports)
 */ $2e28b6be6a2e8b94$export$cac06da4d76d935b.requestResources = async (props)=>{
    const { bootstrapStore: bootstrapStore, requestRouteResources: requestRouteResources } = (0, $bYNku.getRouterStore)().actions;
    const { location: location, timeout: timeout } = props, bootstrapProps = (0, $1eVGO.default)(props, [
        "location",
        "timeout"
    ]);
    const initialEntries = [
        location
    ];
    const overrides = {
        history: (0, $lI7ls.createMemoryHistory)({
            initialEntries: initialEntries
        }),
        location: (0, $gvC5e.createLocation)(location),
        isStatic: true
    };
    bootstrapStore((0, $eb3ax.default)((0, $eb3ax.default)({}, bootstrapProps), overrides));
    await requestRouteResources({
        timeout: timeout,
        isStatic: true
    });
    return (0, $aMVOn.getResourceStore)().actions.getSafeData();
};
$2e28b6be6a2e8b94$export$cac06da4d76d935b.addResourcesListener = (fn)=>(0, $aMVOn.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("3dDXt", function(module, exports) {

var $1eVGO = parcelRequire("1eVGO");


var $cozmU = parcelRequire("cozmU");


var $bYNku = parcelRequire("bYNku");

const $258194dee415192a$export$b371fa9cf762ad06 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bYNku.RouterActionsSubscriber), null, (__, _ref)=>{
        let actions = (0, $1eVGO.default)(_ref, [
            "bootstrapStore",
            "listen",
            "requestRouteResources"
        ]);
        return children(actions);
    });
$258194dee415192a$export$b371fa9cf762ad06.displayName = 'RouterActions';

});

parcelRegister("ij09r", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $ccS36 = parcelRequire("ccS36");


var $cozmU = parcelRequire("cozmU");


var $lI7ls = parcelRequire("lI7ls");


var $aRGWR = parcelRequire("aRGWR");

parcelRequire("9xXrE");
var $3Mxds = parcelRequire("3Mxds");

class $d53a1e66c46ae512$var$Redirector extends (0, $cozmU.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $lI7ls.createPath)((0, $3Mxds.generateLocationFromPath)(to.path, routeAttributes)) : (0, $lI7ls.createPath)(to) : to;
        const currentPath = (0, $lI7ls.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, $ccS36.default)($d53a1e66c46ae512$var$Redirector, "defaultProps", {
    push: false
});
const $d53a1e66c46ae512$export$2d8d895a0a0f636e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGWR.RouterSubscriber), null, ({ location: location }, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d53a1e66c46ae512$var$Redirector, (0, $eb3ax.default)({
            actions: actions,
            location: location
        }, props)));
module.exports["Redirect"] = $d53a1e66c46ae512$export$2d8d895a0a0f636e;

});

parcelRegister("jLcR8", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $cozmU = parcelRequire("cozmU");


var $aRGWR = parcelRequire("aRGWR");

const $e62c6104d7680beb$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $e62c6104d7680beb$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $e62c6104d7680beb$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGWR.RouterSubscriber), null, ({ route: route, location: location, query: query, match: match, action: action, history: history }, { push: push, replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, (0, $eb3ax.default)({}, props, {
                route: route,
                location: location,
                query: query,
                match: match,
                action: action,
                history: history,
                push: push,
                replace: replace
            })));
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});

parcelRegister("lYh42", function(module, exports) {
$parcel$export(module.exports, "useResource", () => (parcelRequire("jfaTG")).useResource);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("hBMVl")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("hBMVl")).useRouterActions);

var $jfaTG = parcelRequire("jfaTG");


var $hBMVl = parcelRequire("hBMVl");


});

parcelRegister("aMVOn", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $j8on0 = parcelRequire("j8on0");

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $5GOpG = parcelRequire("5GOpG");

var $c6StJ = parcelRequire("c6StJ");


var $enqhP = parcelRequire("enqhP");

parcelRequire("1q1Ph");
var $ctEhL = parcelRequire("ctEhL");
var $hJzhp = parcelRequire("hJzhp");
var $kWEHB = parcelRequire("kWEHB");
var $jo8XH = parcelRequire("jo8XH");
var $1r7AH = parcelRequire("1r7AH");
var $7nh8C = parcelRequire("7nh8C");
var $uED1r = parcelRequire("uED1r");
var $7CZpM = parcelRequire("7CZpM");
var $8XvuX = parcelRequire("8XvuX");
var $hrPlk = parcelRequire("hrPlk");
var $5VTgt = parcelRequire("5VTgt");
var $erL2Z = parcelRequire("erL2Z");

const $7dab3b444b64822e$var$PREFETCH_MAX_AGE = 10000;
const $7dab3b444b64822e$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $hJzhp.deleteResourceState)(type, key));
                dispatch((0, $ctEhL.executeForDependents)(resource, (dependentResource)=>$7dab3b444b64822e$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $hJzhp.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, $1eVGO.default)(_getState, [
                "context"
            ]);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $enqhP.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true // promise: existing value retained
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, $eb3ax.default)((0, $eb3ax.default)((0, $eb3ax.default)({}, prevSlice), changes), {}, {
                expiresAt: (0, $7nh8C.getExpiresAt)(maxAge),
                accessedAt: (0, $1r7AH.getAccessedAt)()
            });
            dispatch((0, $hJzhp.setResourceState)(type, key, newSlice)); // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $ctEhL.executeForDependents)(resource, (dependentResource)=>$7dab3b444b64822e$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState2 = getState(), { context: context } = _getState2, resourceStoreState = (0, $1eVGO.default)(_getState2, [
                "context"
            ]);
            const key = getKey(routerStoreContext, context);
            let cached = (0, $enqhP.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            if ((0, $uED1r.shouldUseCache)(cached)) {
                if ((0, $uED1r.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $7CZpM.setSsrDataPromise)(cached);
                    cached = (0, $7nh8C.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $1r7AH.getAccessedAt)();
                dispatch((0, $hJzhp.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($7dab3b444b64822e$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, getData: getData, maxAge: maxAge } = resource;
            const { prefetch: prefetch, timeout: timeout } = options;
            const _getState3 = getState(), { context: context } = _getState3, resourceStoreState = (0, $1eVGO.default)(_getState3, [
                "context"
            ]);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $enqhP.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            }); // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $erL2Z.validateLRUCache)(resource, key)); // hard errors in dependencies or getData are converted into softer async error
            let promiseOrData;
            try {
                promiseOrData = getData((0, $eb3ax.default)((0, $eb3ax.default)({}, routerStoreContext), {}, {
                    isPrefetch: !!prefetch,
                    dependencies: dispatch((0, $ctEhL.getDependencies)(resource, routerStoreContext))
                }), context);
            } catch (error) {
                promiseOrData = Promise.reject(error);
            }
            let resolvedSlice;
            if (promiseOrData === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // ensure the promise includes any timeout error
                const timeoutGuard = timeout ? (0, $jo8XH.generateTimeGuard)(timeout) : null;
                const promise = timeout ? Promise.race([
                    promiseOrData,
                    timeoutGuard == null ? void 0 : timeoutGuard.promise
                ]).then((maybeData)=>{
                    if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $8XvuX.TimeoutError)(type);
                    (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
                    return maybeData;
                }) : (0, $hrPlk.toPromise)(promiseOrData); // enter loading state
                dispatch((0, $hJzhp.setResourceState)(type, key, (0, $eb3ax.default)((0, $eb3ax.default)({}, prevSlice), {}, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    promise: promise,
                    accessedAt: (0, $1r7AH.getAccessedAt)(),
                    // prevent resource from being cleaned prematurely and trigger more network requests.
                    expiresAt: options.prefetch ? (0, $7nh8C.getExpiresAt)($7dab3b444b64822e$var$PREFETCH_MAX_AGE) : prevSlice.expiresAt
                }))); // trigger dependent resources to also load
                dispatch((0, $ctEhL.executeForDependents)(resource, (dependentResource)=>$7dab3b444b64822e$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options))); // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    const data = await promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: promise
                    };
                } catch (error) {
                    if (error instanceof (0, $8XvuX.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: false,
                        promise: promise
                    };
                }
            }
            const finalSlice = (0, $eb3ax.default)((0, $eb3ax.default)((0, $eb3ax.default)({}, (0, $enqhP.getSliceForResource)(getState(), {
                type: type,
                key: key
            })), resolvedSlice), {}, {
                accessedAt: (0, $1r7AH.getAccessedAt)(),
                expiresAt: (0, $7nh8C.getExpiresAt)(options.prefetch && maxAge < $7dab3b444b64822e$var$PREFETCH_MAX_AGE ? $7dab3b444b64822e$var$PREFETCH_MAX_AGE : maxAge)
            });
            if (dispatch((0, $hJzhp.getResourceState)(type, key))) dispatch((0, $hJzhp.setResourceState)(type, key, finalSlice));
            return finalSlice;
        }
};
const $7dab3b444b64822e$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>(0, $ctEhL.actionWithDependencies)(routerStoreContext == null ? void 0 : routerStoreContext.route.resources, resource, $7dab3b444b64822e$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null)),
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, ...args)=>(0, $ctEhL.actionWithDependencies)(routerStoreContext.route.resources, resource, $7dab3b444b64822e$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, ...args)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, ...args)=>(0, $ctEhL.actionWithDependencies)(routerStoreContext.route.resources, resource, $7dab3b444b64822e$export$3f1be494d407b77a.getResource(resource, routerStoreContext, ...args)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, ...args)=>(0, $ctEhL.actionWithDependencies)(routerStoreContext.route.resources, resource, $7dab3b444b64822e$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, ...args)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options)=>({ dispatch: dispatch })=>{
            const { route: route } = routerStoreContext || {};
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($7dab3b444b64822e$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options || {})));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $hJzhp.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $hJzhp.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _routerStoreContext$r;
        const predicate = options.isStatic ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $ctEhL.mapActionWithDependencies)((_routerStoreContext$r = routerStoreContext.route.resources) == null ? void 0 : _routerStoreContext$r.filter(predicate), resources.filter(predicate), (resource)=>$7dab3b444b64822e$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $5VTgt.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, $1eVGO.default)(_ref, [
                    "error",
                    "expiresAt",
                    "loading"
                ]);
                const deserializedError = !error ? null : (0, $kWEHB.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, $eb3ax.default)((0, $eb3ax.default)({}, rest), {}, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $5VTgt.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $kWEHB.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $8XvuX.TimeoutError) ? loading : false
                }))
};
const $7dab3b444b64822e$export$94f50dade551bd01 = (0, $8s9DV.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null
    },
    actions: $7dab3b444b64822e$export$e324594224ef24da,
    name: 'router-resources'
});
const $7dab3b444b64822e$export$cc90fb9c37c5589d = (0, $j8on0.createContainer)($7dab3b444b64822e$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $7dab3b444b64822e$export$303d1e2fcdeb1c96 = (0, $5GOpG.createSubscriber)($7dab3b444b64822e$export$94f50dade551bd01, {
    selector: null
});
const $7dab3b444b64822e$export$fee1a6213543bd78 = (0, $5GOpG.createSubscriber)($7dab3b444b64822e$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $enqhP.getSliceForResource)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $7dab3b444b64822e$export$6f6057d42352becb = ()=>(0, $c6StJ.defaultRegistry).getStore($7dab3b444b64822e$export$94f50dade551bd01);
const $7dab3b444b64822e$export$ac3608e0bb357c7 = (0, $kBr4q.createHook)($7dab3b444b64822e$export$94f50dade551bd01, {
    selector: (0, $enqhP.getSliceForResource)
});
const $7dab3b444b64822e$export$e59f52df235ac7b3 = (0, $kBr4q.createHook)($7dab3b444b64822e$export$94f50dade551bd01, {
    selector: (0, $enqhP.getResourceStoreContext)
});
const $7dab3b444b64822e$export$aad2d56ed8b14bdf = (0, $kBr4q.createHook)($7dab3b444b64822e$export$94f50dade551bd01, {
    selector: null
});
module.exports["getResourceStore"] = $7dab3b444b64822e$export$6f6057d42352becb;
module.exports["useResourceStore"] = $7dab3b444b64822e$export$ac3608e0bb357c7;
module.exports["useResourceActions"] = $7dab3b444b64822e$export$aad2d56ed8b14bdf;

});

parcelRegister("dmaNf", function(module, exports) {

var $9FkRa = parcelRequire("9FkRa");

/**
 * Utility method to created async versions of getData functions
 *
 */ const $9b95b3beae86f32e$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $9b95b3beae86f32e$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $9b95b3beae86f32e$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $9FkRa.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $9FkRa.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $9FkRa.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};
module.exports["createResource"] = $9b95b3beae86f32e$export$edd172c6c83c39cc;

});

parcelRegister("bYNku", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $iTvlA = parcelRequire("iTvlA");

var $j8on0 = parcelRequire("j8on0");

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $5GOpG = parcelRequire("5GOpG");

var $c6StJ = parcelRequire("c6StJ");


var $lI7ls = parcelRequire("lI7ls");


var $edaDW = parcelRequire("edaDW");

parcelRequire("9xXrE");
var $3tzSy = parcelRequire("3tzSy");
var $3Mxds = parcelRequire("3Mxds");
var $dfiOc = parcelRequire("dfiOc");
var $7Yci1 = parcelRequire("7Yci1");
var $d8Wx9 = parcelRequire("d8Wx9");


var $aMVOn = parcelRequire("aMVOn");

parcelRequire("1q1Ph");
var $ixfmZ = parcelRequire("ixfmZ");




var $gjevJ = parcelRequire("gjevJ");



const $8b8b901cb8472bd9$export$36d128238e6b60f5 = {
    history: (0, $edaDW.DEFAULT_HISTORY),
    location: (0, $edaDW.DEFAULT_HISTORY).location,
    query: {},
    routes: [],
    route: (0, $edaDW.DEFAULT_ROUTE),
    match: (0, $edaDW.DEFAULT_MATCH),
    action: (0, $edaDW.DEFAULT_ACTION),
    unlisten: null,
    basePath: '',
    isStatic: false,
    onPrefetch: undefined
};
const $8b8b901cb8472bd9$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { resourceContext: resourceContext, resourceData: resourceData, basePath: basePath = '', routes: routes, initialRoute: initialRoute } = props, initialProps = (0, $1eVGO.default)(props, [
                "resourceContext",
                "resourceData",
                "basePath",
                "routes",
                "initialRoute"
            ]);
            const { history: history, isStatic: isStatic } = initialProps;
            const routerContext = (0, $3tzSy.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $eb3ax.default)((0, $eb3ax.default)((0, $eb3ax.default)({}, initialProps), routerContext), {}, {
                basePath: basePath,
                routes: routes,
                location: history.location,
                action: history.action
            }));
            (0, $aMVOn.getResourceStore)().actions.hydrate({
                resourceContext: resourceContext,
                resourceData: resourceData
            });
            if (!isStatic) dispatch($8b8b901cb8472bd9$var$actions.listen());
        },
    /**
   * Duplicate method that uses isServerEnvironment instead of removed isStatic prop
   * internally. We can remove this when UniversalRouter replaces Router completely.
   */ bootstrapStoreUniversal: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { resourceContext: resourceContext, resourceData: resourceData, basePath: basePath = '' } = props, initialProps = (0, $1eVGO.default)(props, [
                "resourceContext",
                "resourceData",
                "basePath"
            ]);
            const { history: history, routes: routes } = initialProps;
            const routerContext = (0, $3tzSy.findRouterContext)(routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $eb3ax.default)((0, $eb3ax.default)((0, $eb3ax.default)({}, initialProps), routerContext), {}, {
                basePath: basePath,
                location: history.location,
                action: history.action
            }));
            (0, $aMVOn.getResourceStore)().actions.hydrate({
                resourceContext: resourceContext,
                resourceData: resourceData
            });
            if (!(0, $7Yci1.isServerEnvironment)()) dispatch($8b8b901cb8472bd9$var$actions.listen());
        },
    /**
   * Uses the resource store to request resources for the route.
   * Must be dispatched after setting state with the new route context.
   *
   */ requestRouteResources: (options = {})=>({ getState: getState })=>{
            const { route: route, match: match, query: query } = getState();
            return (0, $aMVOn.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, options);
        },
    prefetchNextRouteResources: (path, nextContext)=>({ getState: getState })=>{
            const { routes: routes, basePath: basePath, onPrefetch: onPrefetch, route: route, match: match, query: query } = getState();
            const { cleanExpiredResources: cleanExpiredResources, requestResources: requestResources, getContext: getResourceStoreContext } = (0, $aMVOn.getResourceStore)().actions;
            if (!nextContext && !(0, $gjevJ.isExternalAbsolutePath)(path)) {
                const location = (0, $lI7ls.parsePath)((0, $gjevJ.getRelativePath)(path, basePath));
                nextContext = (0, $3tzSy.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            const nextResources = (0, $ixfmZ.getResourcesForNextLocation)({
                route: route,
                match: match,
                query: query
            }, nextLocationContext, getResourceStoreContext());
            (0, $iTvlA.batch)(()=>{
                cleanExpiredResources(nextResources, nextLocationContext);
                requestResources(nextResources, nextLocationContext, {
                    prefetch: true
                });
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history } = getState();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const { cleanExpiredResources: cleanExpiredResources, requestResources: requestResources, getContext: getResourceStoreContext } = (0, $aMVOn.getResourceStore)().actions;
                const nextContext = (0, $3tzSy.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const nextLocationContext = {
                    route: nextContext.route,
                    match: nextContext.match,
                    query: nextContext.query
                };
                const nextResources = (0, $ixfmZ.getResourcesForNextLocation)({
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                }, nextLocationContext, getResourceStoreContext());
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $iTvlA.batch)(()=>{
                    cleanExpiredResources(nextResources, nextLocationContext);
                    setState((0, $eb3ax.default)((0, $eb3ax.default)({}, nextContext), {}, {
                        location: location,
                        action: action
                    }));
                    requestResources(nextResources, nextLocationContext, {});
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $gjevJ.isExternalAbsolutePath)(path)) window.location.assign(path);
            else history.push((0, $gjevJ.getRelativePath)(path, basePath));
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $3Mxds.generateLocationFromPath)(route.path, (0, $eb3ax.default)((0, $eb3ax.default)({}, attributes), {}, {
                basePath: basePath
            }));
            (0, $d8Wx9.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location);
        },
    replace: (path)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $gjevJ.isExternalAbsolutePath)(path)) window.location.replace(path);
            else history.replace((0, $gjevJ.getRelativePath)(path, basePath));
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $3Mxds.generateLocationFromPath)(route.path, (0, $eb3ax.default)((0, $eb3ax.default)({}, attributes), {}, {
                basePath: basePath
            }));
            (0, $d8Wx9.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            history.goBack();
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            history.goForward();
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, $eb3ax.default)((0, $eb3ax.default)({}, existingQueryParams), params); // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $gjevJ.updateQueryParams)(location, existingQueryParams);
            const updatedPath = (0, $gjevJ.updateQueryParams)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, $eb3ax.default)((0, $eb3ax.default)({}, existingPathParams), params);
            const updatedPath = (0, $dfiOc.default)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, $eb3ax.default)((0, $eb3ax.default)({}, location), {}, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $gjevJ.getRelativeURLFromLocation)(location);
            const updatedRelativePath = (0, $gjevJ.getRelativeURLFromLocation)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        }
};
const $8b8b901cb8472bd9$export$1cf0ecab63b1963c = (0, $8s9DV.createStore)({
    initialState: $8b8b901cb8472bd9$export$36d128238e6b60f5,
    actions: $8b8b901cb8472bd9$var$actions,
    name: 'router'
});
const $8b8b901cb8472bd9$export$d6b817abe7a77ea5 = (0, $j8on0.createContainer)($8b8b901cb8472bd9$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($8b8b901cb8472bd9$var$actions.bootstrapStore(props));
            !props.isStatic && dispatch($8b8b901cb8472bd9$var$actions.requestRouteResources());
        },
    onCleanup: ()=>()=>{}
});
const $8b8b901cb8472bd9$export$b33f9392316de69d = (0, $j8on0.createContainer)($8b8b901cb8472bd9$export$1cf0ecab63b1963c, {
    displayName: 'UniversalRouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($8b8b901cb8472bd9$var$actions.bootstrapStoreUniversal(props));
            !(0, $7Yci1.isServerEnvironment)() && dispatch($8b8b901cb8472bd9$var$actions.requestRouteResources());
        },
    onCleanup: ()=>()=>{}
});
const $8b8b901cb8472bd9$export$672d721d310ff5f0 = (0, $5GOpG.createSubscriber)($8b8b901cb8472bd9$export$1cf0ecab63b1963c, {
    displayName: 'BaseRouterSubscriber'
});
const $8b8b901cb8472bd9$export$afda200b5577e7bf = (0, $5GOpG.createSubscriber)($8b8b901cb8472bd9$export$1cf0ecab63b1963c, {
    displayName: 'RouterActionsSubscriber',
    selector: null
});
const $8b8b901cb8472bd9$export$2e249c5b0c1716a7 = (0, $5GOpG.createSubscriber)($8b8b901cb8472bd9$export$1cf0ecab63b1963c, {
    selector: (state)=>Boolean(state.route && state.route.resources)
});
const $8b8b901cb8472bd9$export$9569010eab09ae9e = (0, $kBr4q.createHook)($8b8b901cb8472bd9$export$1cf0ecab63b1963c);
const $8b8b901cb8472bd9$export$dce62b3e98a54741 = (0, $kBr4q.createHook)($8b8b901cb8472bd9$export$1cf0ecab63b1963c, {
    selector: null
});
function $8b8b901cb8472bd9$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $kBr4q.createHook)($8b8b901cb8472bd9$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $8b8b901cb8472bd9$export$5ccad187366c8494 = ()=>(0, $c6StJ.defaultRegistry).getStore($8b8b901cb8472bd9$export$1cf0ecab63b1963c); // @ts-ignore accessing private store property
const $8b8b901cb8472bd9$export$ebf37f7e180b13a9 = ()=>$8b8b901cb8472bd9$export$5ccad187366c8494().storeState.getState();
module.exports["RouterStore"] = $8b8b901cb8472bd9$export$1cf0ecab63b1963c;
module.exports["RouterContainer"] = $8b8b901cb8472bd9$export$d6b817abe7a77ea5;
module.exports["RouterSubscriber"] = $8b8b901cb8472bd9$export$672d721d310ff5f0;
module.exports["RouterActionsSubscriber"] = $8b8b901cb8472bd9$export$afda200b5577e7bf;
module.exports["useRouterStore"] = $8b8b901cb8472bd9$export$9569010eab09ae9e;
module.exports["useRouterStoreStatic"] = $8b8b901cb8472bd9$export$dce62b3e98a54741;
module.exports["createRouterSelector"] = $8b8b901cb8472bd9$export$95ab46bba7ea7a22;
module.exports["getRouterStore"] = $8b8b901cb8472bd9$export$5ccad187366c8494;
module.exports["getRouterState"] = $8b8b901cb8472bd9$export$ebf37f7e180b13a9;

});

parcelRegister("502Pt", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $lI7ls = parcelRequire("lI7ls");


var $cozmU = parcelRequire("cozmU");

parcelRequire("9xXrE");
var $3tzSy = parcelRequire("3tzSy");
var $3Mxds = parcelRequire("3Mxds");


var $bYNku = parcelRequire("bYNku");




var $hOTZn = parcelRequire("hOTZn");


var $hEpGY = parcelRequire("hEpGY");



const $3a3f25a9b1be1d17$var$PREFETCH_DELAY = 300;
const $3a3f25a9b1be1d17$var$Link = (0, $cozmU.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false } = _ref, rest = (0, $1eVGO.default)(_ref, [
        "children",
        "target",
        "replace",
        "href",
        "to",
        "onClick",
        "onMouseEnter",
        "onMouseLeave",
        "type",
        "params",
        "query",
        "prefetch"
    ]);
    const routerActions = (0, $bYNku.useRouterStoreStatic)()[1];
    const prefetchRef = (0, $cozmU.useRef)();
    const validLinkType = (0, $hOTZn.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $cozmU.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $lI7ls.createPath)((0, $3Mxds.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const triggerPrefetch = (0, $cozmU.useCallback)(()=>{
        prefetchRef.current = undefined; // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $3tzSy.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchNextRouteResources(linkDestination, context); // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $cozmU.useEffect)(()=>{
        let timeout;
        if (prefetch === 'mount') timeout = setTimeout(triggerPrefetch, $3a3f25a9b1be1d17$var$PREFETCH_DELAY);
        return ()=>clearTimeout(timeout);
    }, [
        prefetch,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $hEpGY.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ]
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') prefetchRef.current = setTimeout(triggerPrefetch, $3a3f25a9b1be1d17$var$PREFETCH_DELAY);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover' && prefetchRef.current) {
            clearTimeout(prefetchRef.current);
            prefetchRef.current = undefined;
        }
        onMouseLeave && onMouseLeave(e);
    };
    return (0, $cozmU.createElement)(validLinkType, (0, $eb3ax.default)((0, $eb3ax.default)({}, rest), {}, {
        href: linkDestination,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ref: ref
    }), children);
});
$3a3f25a9b1be1d17$var$Link.displayName = 'Link';
var $3a3f25a9b1be1d17$export$2e2bcd8739ae039 = $3a3f25a9b1be1d17$var$Link;
module.exports["default"] = $3a3f25a9b1be1d17$export$2e2bcd8739ae039;

});

parcelRegister("cfo3c", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

parcelRequire("1n3WU");
var $aRGWR = parcelRequire("aRGWR");

const $8ea98aaca30db9ec$export$7903e4b73fc7d6c3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGWR.RouterSubscriber), null, ({ route: route, location: location, query: query, match: match, action: action })=>!route ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(route.component, {
            route: route,
            location: location,
            query: query,
            match: match,
            action: action
        }));
module.exports["RouteComponent"] = $8ea98aaca30db9ec$export$7903e4b73fc7d6c3;

});

parcelRegister("d8Wx9", function(module, exports) {
$parcel$export(module.exports, "default", () => $99196d43a2f3026d$export$2e2bcd8739ae039);

var $4NiRC = parcelRequire("4NiRC");


var $eb3ax = parcelRequire("eb3ax");

// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $auxYF = parcelRequire("auxYF");

const $d541e3540262bc1e$var$cache = {};
const $d541e3540262bc1e$var$cacheLimit = 10000;
let $d541e3540262bc1e$var$cacheCount = 0;
function $d541e3540262bc1e$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $d541e3540262bc1e$var$cache[cacheKey] || ($d541e3540262bc1e$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, (/*@__PURE__*/$parcel$interopDefault($auxYF)))(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($d541e3540262bc1e$var$cacheCount < $d541e3540262bc1e$var$cacheLimit) {
        pathCache[path] = result;
        $d541e3540262bc1e$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $d541e3540262bc1e$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $d541e3540262bc1e$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $d541e3540262bc1e$export$2e2bcd8739ae039 = $d541e3540262bc1e$var$matchPath;





/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $0bd0b193d23f7d10$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, $eb3ax.default)((0, $eb3ax.default)({}, pathMatch), {}, {
        query: queryMatch
    }) : null;
}
var $0bd0b193d23f7d10$export$2e2bcd8739ae039 = $0bd0b193d23f7d10$var$matchQuery;


/* This should match what react-router does to compute a root match. */ const $cc152310e2745163$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $cc152310e2745163$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $d541e3540262bc1e$export$2e2bcd8739ae039)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $cc152310e2745163$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $0bd0b193d23f7d10$export$2e2bcd8739ae039)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, $eb3ax.default)((0, $eb3ax.default)({}, pathMatch), {}, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $cc152310e2745163$export$2e2bcd8739ae039 = $cc152310e2745163$var$execRouteMatching;


const $835b1d7d0f7736ce$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $835b1d7d0f7736ce$var$MAX_CACHE_SIZE = 1000;
function $835b1d7d0f7736ce$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
     // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$835b1d7d0f7736ce$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $835b1d7d0f7736ce$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($835b1d7d0f7736ce$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $835b1d7d0f7736ce$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $835b1d7d0f7736ce$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};


/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $99196d43a2f3026d$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $4NiRC.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $835b1d7d0f7736ce$export$f594abf16a5ad948).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $cc152310e2745163$export$2e2bcd8739ae039)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $835b1d7d0f7736ce$export$f594abf16a5ad948).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $99196d43a2f3026d$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$99196d43a2f3026d$var$matchRoute(routes, pathname, queryParams, basePath);
const $99196d43a2f3026d$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $99196d43a2f3026d$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $99196d43a2f3026d$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$99196d43a2f3026d$var$matchRoute(routes, pathname, queryParams, basePath);
module.exports["warmupMatchRouteCache"] = $99196d43a2f3026d$export$4e76f1d455ef7c95;

});

parcelRegister("dfiOc", function(module, exports) {

var $auxYF = parcelRequire("auxYF");

const $9a4b441643429513$var$generatePath = (pattern = '/', params)=>pattern === '/' ? pattern : (0, (/*@__PURE__*/$parcel$interopDefault($auxYF))).compile(pattern)(params);
var $9a4b441643429513$export$2e2bcd8739ae039 = $9a4b441643429513$var$generatePath;
module.exports["default"] = $9a4b441643429513$export$2e2bcd8739ae039;

});

parcelRegister("3Mxds", function(module, exports) {

var $auxYF = parcelRequire("auxYF");


var $4NiRC = parcelRequire("4NiRC");

function $2c0f9ed4890165f8$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options; // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $4NiRC.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, (/*@__PURE__*/$parcel$interopDefault($auxYF))).compile(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}
module.exports["generateLocationFromPath"] = $2c0f9ed4890165f8$export$37e0729cc751960b;

});

parcelRegister("kYOHF", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lI7ls = parcelRequire("lI7ls");


var $7SeeH = parcelRequire("7SeeH");


var $eO7Xs = parcelRequire("eO7Xs");

const $f460bdde3b7435ea$var$hasWindow = ()=>typeof window !== 'undefined';
const $f460bdde3b7435ea$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs)))
};
const $f460bdde3b7435ea$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $f460bdde3b7435ea$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $f460bdde3b7435ea$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ]; // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($7SeeH)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $f460bdde3b7435ea$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $f460bdde3b7435ea$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $f460bdde3b7435ea$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, $eb3ax.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return $f460bdde3b7435ea$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $f460bdde3b7435ea$var$hasWindow() ? {
        push: (path)=>window.location.assign(path),
        replace: (path)=>window.history.replaceState({}, document.title, path),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $f460bdde3b7435ea$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
        createHref: (location)=>(0, $lI7ls.createPath)(location)
    } : $f460bdde3b7435ea$var$methodsPlaceholders);
};
module.exports["createLegacyHistory"] = $f460bdde3b7435ea$export$883c3f3b6c000133;

});

parcelRegister("7Yci1", function(module, exports) {
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $1P2f3 = parcelRequire("1P2f3");

const $5cd7ab75db66e8aa$var$isJsDomEnvironment = ()=>window.name === 'nodejs' || navigator.userAgent.includes('Node.js') || navigator.userAgent.includes('jsdom');
const $5cd7ab75db66e8aa$export$455cc18296abe008 = ()=>{
    if (typeof $1P2f3 !== 'undefined' && $1P2f3.versions != null && $1P2f3.versions.node != null) return true;
    if ($5cd7ab75db66e8aa$var$isJsDomEnvironment()) return true;
    return false;
};
module.exports["isServerEnvironment"] = $5cd7ab75db66e8aa$export$455cc18296abe008;

});

parcelRegister("3tzSy", function(module, exports) {

var $4NiRC = parcelRequire("4NiRC");


var $edaDW = parcelRequire("edaDW");


var $d8Wx9 = parcelRequire("d8Wx9");


var $dfiOc = parcelRequire("dfiOc");

const $287fe95771ab16a9$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $dfiOc.default)(route.path, params);
    const matchedRoute = (0, $d8Wx9.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $edaDW.DEFAULT_MATCH),
        query: query
    };
};
const $287fe95771ab16a9$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $4NiRC.qs).parse(search);
    const matchedRoute = (0, $d8Wx9.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $edaDW.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $edaDW.DEFAULT_MATCH)
    };
};
module.exports["createRouterContext"] = $287fe95771ab16a9$export$faed15f35ddc6f99;
module.exports["findRouterContext"] = $287fe95771ab16a9$export$a0bd0313cbeabd49;

});

parcelRegister("9hl2F", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jfaTG = parcelRequire("jfaTG");

const $6c160616128496d3$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $jfaTG.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(result));
};

});

parcelRegister("aRGWR", function(module, exports) {

var $1eVGO = parcelRequire("1eVGO");


var $cozmU = parcelRequire("cozmU");


var $bYNku = parcelRequire("bYNku");

const $7e902b3fd5599a9f$export$672d721d310ff5f0 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bYNku.RouterSubscriber), null, (state, _ref)=>{
        let { listen: listen } = _ref, actions = (0, $1eVGO.default)(_ref, [
            "listen"
        ]);
        if (!state.unlisten && !state.isStatic) listen();
        return children(state, actions);
    });
module.exports["RouterSubscriber"] = $7e902b3fd5599a9f$export$672d721d310ff5f0;

});

parcelRegister("gvC5e", function(module, exports) {
class $a3b964082e188ff0$var$DecodeUriError extends URIError {
    constructor(path){
        super(`Pathname ${path} could not be decoded. This is likely caused by an invalid percent-encoding.`);
    }
}
function $a3b964082e188ff0$export$cd27bea214d030c2(path) {
    try {
        return decodeURI(path);
    } catch (e) {
        if (e instanceof URIError) throw new $a3b964082e188ff0$var$DecodeUriError(path);
        else throw e;
    }
}



var $4NiRC = parcelRequire("4NiRC");

function $7800ba72730c3398$export$8ccf933b0513f8d0(path) {
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(path, 'ws://a.a');
    const isAbsolute = path.startsWith('/');
    const pathname = isAbsolute || url.pathname === '/' ? url.pathname : url.pathname.slice(1);
    return {
        pathname: pathname,
        search: url.query,
        hash: url.hash
    };
}


function $c04d152e4a7ac476$export$90c043f1c57770b8(path = '') {
    const location = (0, $7800ba72730c3398$export$8ccf933b0513f8d0)(path);
    location.pathname = (0, $a3b964082e188ff0$export$cd27bea214d030c2)(location.pathname);
    return location;
}
module.exports["createLocation"] = $c04d152e4a7ac476$export$90c043f1c57770b8;

});

parcelRegister("jfaTG", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $cozmU = parcelRequire("cozmU");


var $aMVOn = parcelRequire("aMVOn");


var $bYNku = parcelRequire("bYNku");


var $kBr4q = parcelRequire("kBr4q");

const $e027defcb10c4b14$export$9f6abfd74295843b = (resource, options)=>{
    const [, actions] = (0, $aMVOn.useResourceActions)();
    const [, { getContext: getRouterContext }] = (0, $bYNku.useRouterStoreStatic)(); // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $cozmU.useMemo)(()=>(0, $kBr4q.createHook)((0, $bYNku.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $aMVOn.useResourceStore)({
        type: resource.type,
        key: key
    }); // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $cozmU.useMemo)(()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), [
        key
    ]);
    const update = (0, $cozmU.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $cozmU.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $cozmU.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $cozmU.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $eb3ax.default)((0, $eb3ax.default)({}, slice), {}, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};
module.exports["useResource"] = $e027defcb10c4b14$export$9f6abfd74295843b;

});

parcelRegister("hBMVl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");


var $bYNku = parcelRequire("bYNku");

const $cd1bd7a22c3d9a84$export$9a302a45f65d0572 = ()=>{
    const [entireState, allActions] = (0, $bYNku.useRouterStore)();
    return [
        entireState,
        allActions
    ];
};
const $cd1bd7a22c3d9a84$export$402e82ff1b20594b = ()=>{
    const [, allActions] = (0, $bYNku.useRouterStoreStatic)();
    return allActions;
};
const $cd1bd7a22c3d9a84$var$createQueryParamHook = (0, $kBr4q.createHook)((0, $bYNku.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $cd1bd7a22c3d9a84$var$createPathParamHook = (0, $kBr4q.createHook)((0, $bYNku.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $cd1bd7a22c3d9a84$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $cd1bd7a22c3d9a84$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};
const $cd1bd7a22c3d9a84$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $cd1bd7a22c3d9a84$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};
module.exports["useRouter"] = $cd1bd7a22c3d9a84$export$9a302a45f65d0572;
module.exports["useRouterActions"] = $cd1bd7a22c3d9a84$export$402e82ff1b20594b;

});

parcelRegister("uED1r", function(module, exports) {
const $05c251688bc931dc$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $05c251688bc931dc$var$isFresh = (resource)=>{
    if ($05c251688bc931dc$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $05c251688bc931dc$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null ? void 0 : (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($05c251688bc931dc$var$isFresh(resource)) return true;
    return false;
};
module.exports["isFromSsr"] = $05c251688bc931dc$export$b25d2963b8a3488a;
module.exports["shouldUseCache"] = $05c251688bc931dc$export$399de8c43d0ece3c;

});

parcelRegister("dHTu0", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $9FkRa = parcelRequire("9FkRa");


var $7nh8C = parcelRequire("7nh8C");


var $1r7AH = parcelRequire("1r7AH");

const $9faa5445ba542df3$export$fa8e33c3301e2e94 = ()=>(0, $eb3ax.default)((0, $eb3ax.default)({}, (0, $9FkRa.BASE_DEFAULT_STATE_SLICE)), {}, {
        expiresAt: (0, $7nh8C.getExpiresAt)((0, $9FkRa.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $1r7AH.getAccessedAt)()
    });
module.exports["getDefaultStateSlice"] = $9faa5445ba542df3$export$fa8e33c3301e2e94;

});

parcelRegister("7nh8C", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");

const $55e7f9a88951e76c$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $55e7f9a88951e76c$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, $eb3ax.default)((0, $eb3ax.default)({}, slice), {}, {
        expiresAt: $55e7f9a88951e76c$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;
module.exports["getExpiresAt"] = $55e7f9a88951e76c$export$b65d7ba7fbf150f1;
module.exports["setExpiresAt"] = $55e7f9a88951e76c$export$18d1d420fd588368;

});

parcelRegister("1r7AH", function(module, exports) {
const $10be33746fa88541$export$9ccb639b7a119f61 = ()=>Date.now();
module.exports["getAccessedAt"] = $10be33746fa88541$export$9ccb639b7a119f61;

});

parcelRegister("koRU0", function(module, exports) {
const $ed9fdc6f043b1888$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $ed9fdc6f043b1888$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$ed9fdc6f043b1888$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));
module.exports["getResourceIdentifier"] = $ed9fdc6f043b1888$export$c616b176adf9ad4a;
module.exports["getResourceIdentifiers"] = $ed9fdc6f043b1888$export$cd7fbe7e979df558;

});

parcelRegister("ixfmZ", function(module, exports) {

var $koRU0 = parcelRequire("koRU0");


var $9Blma = parcelRequire("9Blma");

const $d7e73b358ab723c4$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $9Blma.routeHasResources)(nextRoute)) return [];
    if ((0, $9Blma.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $koRU0.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $koRU0.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};
module.exports["getResourcesForNextLocation"] = $d7e73b358ab723c4$export$7cbbc763e2f3d65d;

});

parcelRegister("jo8XH", function(module, exports) {
const $e1d735d8cd9a4892$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};
module.exports["generateTimeGuard"] = $e1d735d8cd9a4892$export$58634b3a58ae66b7;

});

parcelRegister("kWEHB", function(module, exports) {
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $f3f8cc0aff7853de$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $f3f8cc0aff7853de$var$NonError);
    }
}
const $f3f8cc0aff7853de$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $f3f8cc0aff7853de$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $f3f8cc0aff7853de$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $f3f8cc0aff7853de$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
}; // const serializeError = <ErrorType = any>(value: ErrorType) => {
const $f3f8cc0aff7853de$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $f3f8cc0aff7853de$var$destroyCircular(value, []);
     // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $f3f8cc0aff7853de$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $f3f8cc0aff7853de$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $f3f8cc0aff7853de$var$NonError(value);
};
module.exports["serializeError"] = $f3f8cc0aff7853de$export$46ff38bc6bdea8fb;
module.exports["deserializeError"] = $f3f8cc0aff7853de$export$64cddc1e268e9046;

});

parcelRegister("5VTgt", function(module, exports) {
const $011d5f90b0bdc406$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});
module.exports["transformData"] = $011d5f90b0bdc406$export$3ceb62baab058c6b;

});

parcelRegister("9Blma", function(module, exports) {
const $6fd822bb9b1574e2$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $6fd822bb9b1574e2$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;
module.exports["routeHasResources"] = $6fd822bb9b1574e2$export$740886389191c640;
module.exports["routeHasChanged"] = $6fd822bb9b1574e2$export$221027ff1aa38f82;

});

parcelRegister("8XvuX", function(module, exports) {
class $685c4456de70e97b$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}
module.exports["TimeoutError"] = $685c4456de70e97b$export$66d311bf29d5c89c;

});

parcelRegister("7CZpM", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");

const $58dbb8b3bc123bb8$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, $eb3ax.default)((0, $eb3ax.default)({}, slice), {}, {
        promise: Promise.resolve(slice.data)
    }) : slice;
module.exports["setSsrDataPromise"] = $58dbb8b3bc123bb8$export$2e4da1b414980956;

});

parcelRegister("erL2Z", function(module, exports) {

var $hJzhp = parcelRequire("hJzhp");

const $a84814eca6052ac7$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $a84814eca6052ac7$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $a84814eca6052ac7$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $a84814eca6052ac7$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $a84814eca6052ac7$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $hJzhp.deleteResourceState)(type, keyTobeDeleted));
    };
module.exports["validateLRUCache"] = $a84814eca6052ac7$export$89440b7623c2c75c;

});

parcelRegister("hJzhp", function(module, exports) {

var $1eVGO = parcelRequire("1eVGO");


var $eb3ax = parcelRequire("eb3ax");

function $ce92017916374f67$var$_toPropertyKey(arg) {
    var key = $ce92017916374f67$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $ce92017916374f67$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
const $ce92017916374f67$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState })=>{
        const { data: data } = getState();
        setState({
            data: (0, $eb3ax.default)((0, $eb3ax.default)({}, data), {}, {
                [type]: (0, $eb3ax.default)((0, $eb3ax.default)({}, data[type] || {}), {}, {
                    [key]: state
                })
            })
        });
    };
const $ce92017916374f67$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $ce92017916374f67$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, $1eVGO.default)(data, [
            type
        ].map($ce92017916374f67$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, $1eVGO.default)(resourceForType, [
                key
            ].map($ce92017916374f67$var$_toPropertyKey));
            setState({
                data: (0, $eb3ax.default)((0, $eb3ax.default)({}, remainingData), {}, {
                    [type]: remainingForType
                })
            });
        }
    };
module.exports["setResourceState"] = $ce92017916374f67$export$704f800f263b050e;
module.exports["getResourceState"] = $ce92017916374f67$export$5fc90c33b03fffb;
module.exports["deleteResourceState"] = $ce92017916374f67$export$d40f35dc5952864b;

});

parcelRegister("ctEhL", function(module, exports) {

var $enqhP = parcelRequire("enqhP");

var $91577151a685c1df$var$_Object$fromEntries;
const $91577151a685c1df$var$fromEntries = ($91577151a685c1df$var$_Object$fromEntries = Object.fromEntries) != null ? $91577151a685c1df$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $91577151a685c1df$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $91577151a685c1df$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $91577151a685c1df$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
         // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
         // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($91577151a685c1df$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
         // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends == null ? void 0 : depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i); // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
         // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i); // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($91577151a685c1df$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        }); // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        }); // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($91577151a685c1df$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $91577151a685c1df$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($91577151a685c1df$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $91577151a685c1df$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$91577151a685c1df$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $91577151a685c1df$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState(); // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($91577151a685c1df$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
         // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && ((_tupleResource$depend = tupleResource.depends) == null ? void 0 : _tupleResource$depend.includes(resource.type)) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $91577151a685c1df$export$75915f81f2a6540a = (resource, routerStoreContext)=>({ getState: getState })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource; // optimise the case of no dependencies
        if (!(depends == null ? void 0 : depends.length)) return {};
        const { executing: tuples, data: data, context: resourceStoreContext } = getState(); // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($91577151a685c1df$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $91577151a685c1df$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
         // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($91577151a685c1df$var$matchType({
                    type: dependency
                }))
            ]); // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $91577151a685c1df$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $91577151a685c1df$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $91577151a685c1df$var$fromEntries(dependencyIndexTuples.map(([dependency, index])=>{
            const [{ getKey: getKey }] = tuples[index];
            return [
                dependency,
                (0, $enqhP.getSliceForResource)({
                    data: data
                }, {
                    type: dependency,
                    key: getKey(routerStoreContext, resourceStoreContext)
                })
            ];
        }));
    };
module.exports["actionWithDependencies"] = $91577151a685c1df$export$5f7e1fd85734e71e;
module.exports["mapActionWithDependencies"] = $91577151a685c1df$export$f71a65c89c987a02;
module.exports["executeForDependents"] = $91577151a685c1df$export$7d1ffac63c68405d;
module.exports["getDependencies"] = $91577151a685c1df$export$75915f81f2a6540a;

});

parcelRegister("hrPlk", function(module, exports) {
const $cb3cc8eb66da503f$export$4dbaaf6c79705e6c = (candidate)=>candidate instanceof Promise ? candidate : Promise.resolve(candidate);
module.exports["toPromise"] = $cb3cc8eb66da503f$export$4dbaaf6c79705e6c;

});

parcelRegister("edaDW", function(module, exports) {

var $eO7Xs = parcelRequire("eO7Xs");


var $kYOHF = parcelRequire("kYOHF");

const $a58a891cbec87835$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $a58a891cbec87835$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $a58a891cbec87835$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $a58a891cbec87835$export$39607c9878cf5148 = (0, $kYOHF.createLegacyHistory)();
const $a58a891cbec87835$export$1515254c8c90bebb = {
    location: $a58a891cbec87835$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs)))
};
const $a58a891cbec87835$export$fa440ddf675c8a93 = 'POP';
module.exports["DEFAULT_MATCH"] = $a58a891cbec87835$export$2de13e891a662beb;
module.exports["DEFAULT_ROUTE"] = $a58a891cbec87835$export$4eadc79233226325;
module.exports["DEFAULT_HISTORY"] = $a58a891cbec87835$export$39607c9878cf5148;
module.exports["DEFAULT_ACTION"] = $a58a891cbec87835$export$fa440ddf675c8a93;

});

parcelRegister("1q1Ph", function(module, exports) {
$parcel$export(module.exports, "shouldUseCache", () => (parcelRequire("uED1r")).shouldUseCache);
$parcel$export(module.exports, "isFromSsr", () => (parcelRequire("uED1r")).isFromSsr);
$parcel$export(module.exports, "getDefaultStateSlice", () => (parcelRequire("dHTu0")).getDefaultStateSlice);
$parcel$export(module.exports, "getExpiresAt", () => (parcelRequire("7nh8C")).getExpiresAt);
$parcel$export(module.exports, "setExpiresAt", () => (parcelRequire("7nh8C")).setExpiresAt);
$parcel$export(module.exports, "getAccessedAt", () => (parcelRequire("1r7AH")).getAccessedAt);
$parcel$export(module.exports, "getResourcesForNextLocation", () => (parcelRequire("ixfmZ")).getResourcesForNextLocation);
$parcel$export(module.exports, "generateTimeGuard", () => (parcelRequire("jo8XH")).generateTimeGuard);
$parcel$export(module.exports, "serializeError", () => (parcelRequire("kWEHB")).serializeError);
$parcel$export(module.exports, "deserializeError", () => (parcelRequire("kWEHB")).deserializeError);
$parcel$export(module.exports, "transformData", () => (parcelRequire("5VTgt")).transformData);
$parcel$export(module.exports, "TimeoutError", () => (parcelRequire("8XvuX")).TimeoutError);
$parcel$export(module.exports, "setSsrDataPromise", () => (parcelRequire("7CZpM")).setSsrDataPromise);
$parcel$export(module.exports, "validateLRUCache", () => (parcelRequire("erL2Z")).validateLRUCache);
$parcel$export(module.exports, "deleteResourceState", () => (parcelRequire("hJzhp")).deleteResourceState);
$parcel$export(module.exports, "getResourceState", () => (parcelRequire("hJzhp")).getResourceState);
$parcel$export(module.exports, "setResourceState", () => (parcelRequire("hJzhp")).setResourceState);
$parcel$export(module.exports, "actionWithDependencies", () => (parcelRequire("ctEhL")).actionWithDependencies);
$parcel$export(module.exports, "mapActionWithDependencies", () => (parcelRequire("ctEhL")).mapActionWithDependencies);
$parcel$export(module.exports, "executeForDependents", () => (parcelRequire("ctEhL")).executeForDependents);
$parcel$export(module.exports, "getDependencies", () => (parcelRequire("ctEhL")).getDependencies);
$parcel$export(module.exports, "toPromise", () => (parcelRequire("hrPlk")).toPromise);

var $uED1r = parcelRequire("uED1r");


var $dHTu0 = parcelRequire("dHTu0");


var $7nh8C = parcelRequire("7nh8C");


var $1r7AH = parcelRequire("1r7AH");


var $koRU0 = parcelRequire("koRU0");


var $ixfmZ = parcelRequire("ixfmZ");


var $jo8XH = parcelRequire("jo8XH");


var $kWEHB = parcelRequire("kWEHB");


var $5VTgt = parcelRequire("5VTgt");


var $9Blma = parcelRequire("9Blma");


var $8XvuX = parcelRequire("8XvuX");


var $7CZpM = parcelRequire("7CZpM");


var $erL2Z = parcelRequire("erL2Z");


var $hJzhp = parcelRequire("hJzhp");


var $ctEhL = parcelRequire("ctEhL");


var $hrPlk = parcelRequire("hrPlk");


});

parcelRegister("gjevJ", function(module, exports) {

var $4NiRC = parcelRequire("4NiRC");

const $bdf9ad3d7015a3ac$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $bdf9ad3d7015a3ac$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $bdf9ad3d7015a3ac$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $bdf9ad3d7015a3ac$var$stripTrailingSlash(prefix);
        prefix = $bdf9ad3d7015a3ac$var$addLeadingSlash(prefix);
        path = $bdf9ad3d7015a3ac$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $bdf9ad3d7015a3ac$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $bdf9ad3d7015a3ac$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$bdf9ad3d7015a3ac$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $bdf9ad3d7015a3ac$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$bdf9ad3d7015a3ac$export$e83e3719fc818ee5(path)) {
        path = $bdf9ad3d7015a3ac$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $bdf9ad3d7015a3ac$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $4NiRC.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $bdf9ad3d7015a3ac$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
module.exports["isExternalAbsolutePath"] = $bdf9ad3d7015a3ac$export$2fa6dede99f181e5;
module.exports["getRelativePath"] = $bdf9ad3d7015a3ac$export$ae9fda833d91ed65;
module.exports["updateQueryParams"] = $bdf9ad3d7015a3ac$export$92377f461a797888;
module.exports["getRelativeURLFromLocation"] = $bdf9ad3d7015a3ac$export$9ae1c7c875ef309d;

});

parcelRegister("hOTZn", function(module, exports) {
const $cf92896aa40bda2e$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $cf92896aa40bda2e$export$855ece989b15eb57 = (type)=>$cf92896aa40bda2e$var$VALID_LINK_TYPES.includes(type) ? type : 'a';
module.exports["getValidLinkType"] = $cf92896aa40bda2e$export$855ece989b15eb57;

});

parcelRegister("hEpGY", function(module, exports) {
const $03a86796ac28eae0$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $03a86796ac28eae0$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);


const $cd9a1a0852085c17$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to })=>{
    if ((0, $03a86796ac28eae0$export$130b789831072f4c)(event) && event.keyCode !== 13) return;
    onClick && onClick(event);
    if (!event.defaultPrevented && ((0, $03a86796ac28eae0$export$130b789831072f4c)(event) && event.keyCode === 13 || event.button === 0) && (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $03a86796ac28eae0$export$642c6f14f6d4bbd5)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href);
        }
    }
};
module.exports["handleNavigation"] = $cd9a1a0852085c17$export$706ad1af8096e280;

});

parcelRegister("auxYF", function(module, exports) {

var $eRPzL = parcelRequire("eRPzL");

/**
 * Expose `pathToRegexp`.
 */ module.exports = $7a370ff27fef813f$var$pathToRegexp;
module.exports.parse = $7a370ff27fef813f$var$parse;
module.exports.compile = $7a370ff27fef813f$var$compile;
module.exports.tokensToFunction = $7a370ff27fef813f$var$tokensToFunction;
module.exports.tokensToRegExp = $7a370ff27fef813f$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $7a370ff27fef813f$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $7a370ff27fef813f$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $7a370ff27fef813f$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $7a370ff27fef813f$var$escapeGroup(pattern) : asterisk ? '.*' : $7a370ff27fef813f$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $7a370ff27fef813f$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $7a370ff27fef813f$var$escapeString(delimiter) + ']+?';
    return $7a370ff27fef813f$var$escapeString(prevText) + '|(?:(?!' + $7a370ff27fef813f$var$escapeString(prevText) + ')[^' + $7a370ff27fef813f$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $7a370ff27fef813f$var$compile(str, options) {
    return $7a370ff27fef813f$var$tokensToFunction($7a370ff27fef813f$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $7a370ff27fef813f$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $7a370ff27fef813f$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $7a370ff27fef813f$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $7a370ff27fef813f$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $7a370ff27fef813f$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($eRPzL(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $7a370ff27fef813f$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $7a370ff27fef813f$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $7a370ff27fef813f$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $7a370ff27fef813f$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $7a370ff27fef813f$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $7a370ff27fef813f$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $7a370ff27fef813f$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $7a370ff27fef813f$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($7a370ff27fef813f$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $7a370ff27fef813f$var$flags(options));
    return $7a370ff27fef813f$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $7a370ff27fef813f$var$stringToRegexp(path, keys, options) {
    return $7a370ff27fef813f$var$tokensToRegExp($7a370ff27fef813f$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $7a370ff27fef813f$var$tokensToRegExp(tokens, keys, options) {
    if (!$eRPzL(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $7a370ff27fef813f$var$escapeString(token);
        else {
            var prefix = $7a370ff27fef813f$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $7a370ff27fef813f$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $7a370ff27fef813f$var$attachKeys(new RegExp('^' + route, $7a370ff27fef813f$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $7a370ff27fef813f$var$pathToRegexp(path, keys, options) {
    if (!$eRPzL(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $7a370ff27fef813f$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($eRPzL(path)) return $7a370ff27fef813f$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $7a370ff27fef813f$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});

parcelRegister("9FkRa", function(module, exports) {
const $70981f1330227e6e$export$12c1dc38ea1692da = 0;
const $70981f1330227e6e$export$881d135f98d8d7d0 = 100;
const $70981f1330227e6e$export$9ab5bdcb8a1d6c34 = false;
const $70981f1330227e6e$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};
module.exports["DEFAULT_RESOURCE_MAX_AGE"] = $70981f1330227e6e$export$12c1dc38ea1692da;
module.exports["DEFAULT_CACHE_MAX_LIMIT"] = $70981f1330227e6e$export$881d135f98d8d7d0;
module.exports["DEFAULT_RESOURCE_BROWSER_ONLY"] = $70981f1330227e6e$export$9ab5bdcb8a1d6c34;
module.exports["BASE_DEFAULT_STATE_SLICE"] = $70981f1330227e6e$export$2df85a734ff5ed27;

});

parcelRegister("enqhP", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");

parcelRequire("1q1Ph");
var $dHTu0 = parcelRequire("dHTu0");

const $a7779aa733d521cf$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, $eb3ax.default)({}, slice) : (0, $dHTu0.getDefaultStateSlice)();
};
const $a7779aa733d521cf$export$6a0b1779210de0ee = (state)=>state.context;
module.exports["getSliceForResource"] = $a7779aa733d521cf$export$c9ed509724feb827;
module.exports["getResourceStoreContext"] = $a7779aa733d521cf$export$6a0b1779210de0ee;

});

parcelRegister("eRPzL", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

});


//# sourceMappingURL=edition-benefits-modal-relay.ace65b63.js.map
